import { render, staticRenderFns } from "./statusWorkLeave.vue?vue&type=template&id=7636a43c&scoped=true&"
import script from "./statusWorkLeave.vue?vue&type=script&lang=js&"
export * from "./statusWorkLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7636a43c",
  null
  
)

export default component.exports